export { default as AppointmentDetailsItem } from './AppointmentDetailsItem';
